import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99679dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
  "data-test-dialog-container": ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fixed inset-0 bg-gray-700 opacity-70 transition-opacity",
  "aria-hidden": "true",
  "data-test-backdrop": ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true",
  "data-test-zero-width-space": ""
}, " ​ ", -1))
const _hoisted_4 = {
  class: "align-middle container inline-block px-4 bg-black-50 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:px-16 sm:py-8",
  "data-test-dialog": ""
}
const _hoisted_5 = {
  class: "mt-3",
  "data-test-dialog-header": ""
}
const _hoisted_6 = ["data-title", "data-title-rotate"]
const _hoisted_7 = {
  class: "pt-5 pb-4",
  "data-test-dialog-body": ""
}
const _hoisted_8 = ["data-description", "data-description-rotate"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'potentially-rotatable': _ctx.potentiallyRotatable }, "screen-dimensions-dialog fixed inset-0 overflow-y-auto"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", {
            "data-title": _ctx.dialogTexts.title,
            "data-title-rotate": _ctx.dialogTexts.rotateTitle,
            class: "title text-xl leading-6 font-bold text-gray-900 before:content-[attr(data-title)]",
            "data-test-dialog-heading": ""
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", {
            "data-description": _ctx.dialogTexts.description,
            "data-description-rotate": _ctx.dialogTexts.rotateDescription,
            class: "description before:content-[attr(data-description)]",
            "data-test-dialog-description": ""
          }, null, 8, _hoisted_8)
        ])
      ])
    ])
  ], 2))
}